module.exports = __webpack_public_path__ + "media/images/element/music-8310372ba7b5f1b0a027030b1b646e60.svg";